import { useOutletContext } from 'react-router-dom';
import Popup from '@components/common/Popup/Popup';
import PopupContent from '@components/common/Popup/PopupContent/index';
import Body from '../../components/Body';
import ExpandedView from '@components/Fireboard/components/ExpandedView';
import FullWidthModal from '../../../common/Modal/FullWidthModal';
import style from './desktop.module.css';
import constant from '@components/common/globalization';
import EmailReceipt from '@components/common/EmailReceipt';
import SmsReceipt from '@components/common/SmsReceipt';
import BulktextToPay from '../../components/BulkTextToPay';
import OutOfStock from '../../../../containers/Fireboard/hamContainers/OutOfStock';
import ErrorOrders from '../../components/ErrorOrders/index';

// import screens
const Desktop = props => {
  const {
    popup,
    isExpanded,
    setIsExpanded,
    setPopup,
    currency,
    countryCode,
  } = props;
  const { emailReceiptHandler, smsReceiptHandler } = useOutletContext();
  const getPopupContent = () => {
    if (!popup) return null;
    switch (popup.type) {
      case constant.EMAIL_RECEIPT:
        return (
          <EmailReceipt setPopup={setPopup} onSubmit={emailReceiptHandler} />
        );
      case constant.SMS_RECEIPT:
        return (
          <SmsReceipt
            setPopup={setPopup}
            onSubmit={smsReceiptHandler}
            defaultPhoneNumber={popup.metaData?.phoneNumber}
            defaultCountryCode={popup.metaData?.countryCode}
          />
        );
      case constant.BULK_TEXT_TO_PAY:
        return <BulktextToPay currency={currency} countryCode={countryCode} />;
      case constant.OUT_OF_STOCK:
        return <OutOfStock setPopup={setPopup} />;
      case constant.ERROR_ORDERS:
        return <ErrorOrders setPopup={setPopup} />;
      default: {
        return <PopupContent {...popup} />;
      }
    }
  };
  const getPopupViewType = () => {
    if (!popup) return null;
    let isFullWidth = false;
    switch (popup.type) {
      case constant.EMAIL_RECEIPT:
        isFullWidth = false;
        break;
      case constant.SMS_RECEIPT:
        isFullWidth = false;
        break;
      case constant.BULK_TEXT_TO_PAY:
        isFullWidth = true;
        break;
      case constant.OUT_OF_STOCK:
        isFullWidth = true;
        break;
      case constant.NOTIFICATIONS:
        isFullWidth = true;
        break;
      case constant.ERROR_ORDERS:
        isFullWidth = true;
        break;
      default: {
        isFullWidth = false;
        break;
      }
    }
    return isFullWidth;
  };
  return (
    <div className="w-100 h-100">
      <Popup visible={!!popup} fullPopupView={getPopupViewType()}>
        {getPopupContent()}
      </Popup>
      <FullWidthModal
        isOpen={isExpanded}
        customClass={style.modalContainerBg}
        customClass2="h-100"
        style={{ height: '100%' }}
      >
        <ExpandedView
          {...props}
          setIsExpanded={setIsExpanded}
          isExpanded={isExpanded}
        />
      </FullWidthModal>
      <div className="flex-grow-1 h-100">
        <Body
          {...props}
          isExpanded={isExpanded}
          setIsExpanded={setIsExpanded}
        />
      </div>
    </div>
  );
};
export default Desktop;
